// Forge 3.20 core ships the app layout, user profile and count card (formerly forge-extended).
import {
  IconRegistry,
  defineAutocompleteComponent,
  defineBadgeComponent,
  defineBannerComponent,
  defineButtonComponent,
  defineButtonToggleGroupComponent,
  defineCardComponent,
  defineCheckboxComponent,
  defineChipComponent,
  defineChipSetComponent,
  defineCircularProgressComponent,
  defineDialogComponent,
  defineDividerComponent,
  defineIconButtonComponent,
  defineIconComponent,
  defineInlineMessageComponent,
  defineLabelValueComponent,
  defineListComponent,
  defineListItemComponent,
  defineOptionComponent,
  defineOptionGroupComponent,
  definePageStateComponent,
  definePaginatorComponent,
  defineSelectComponent,
  defineSkeletonComponent,
  defineTabBarComponent,
  defineTabComponent,
  defineTextFieldComponent,
  defineToastComponent,
  defineToolbarComponent,
  defineTooltipComponent,
} from "@tylertech/forge";
// Not re-exported from the package root in 3.20; imported by subpath.
import { defineAppLayoutComponent } from "@tylertech/forge/app-layout";
import { defineCountCardComponent } from "@tylertech/forge/count-card";
import { defineUserProfileComponent } from "@tylertech/forge/user-profile";
import {
  tylIconAdd,
  tylIconAdminPanelSettings,
  tylIconAltRoute,
  tylIconArrowDownward,
  tylIconArrowUpward,
  tylIconAutoAwesome,
  tylIconAutorenew,
  tylIconBadge,
  tylIconBarChart,
  tylIconCheckCircle,
  tylIconClose,
  tylIconCode,
  tylIconContentCopy,
  tylIconDeleteOutline,
  tylIconError,
  tylIconHistory,
  tylIconHome,
  tylIconInfo,
  tylIconKeyboardArrowDown,
  tylIconKeyboardArrowUp,
  tylIconLightbulb,
  tylIconMemory,
  tylIconMenuBook,
  tylIconOpenInNew,
  tylIconPeople,
  tylIconPiggyBank,
  tylIconPsychology,
  tylIconReceiptLong,
  tylIconRefresh,
  tylIconSchedule,
  tylIconSearch,
  tylIconSettings,
  tylIconShowChart,
  tylIconTableChart,
  tylIconTag,
  tylIconUnfoldMore,
  tylIconVpnKey,
  tylIconWarning,
} from "@tylertech/tyler-icons";
import "@tylertech/forge/dist/forge.css";
import darkThemeUrl from "@tylertech/forge/dist/forge-dark.css?url";

for (const define of [
  defineAppLayoutComponent, defineAutocompleteComponent, defineBadgeComponent, defineBannerComponent, defineButtonComponent, defineButtonToggleGroupComponent,
  defineCardComponent, defineCheckboxComponent, defineChipComponent, defineChipSetComponent,
  defineCircularProgressComponent, defineCountCardComponent, defineDialogComponent, defineDividerComponent,
  defineIconButtonComponent, defineIconComponent, defineInlineMessageComponent, defineLabelValueComponent,
  defineListComponent, defineListItemComponent, defineOptionComponent, defineOptionGroupComponent, definePageStateComponent,
  definePaginatorComponent, defineSelectComponent, defineSkeletonComponent, defineTabBarComponent,
  defineTabComponent, defineTextFieldComponent, defineToastComponent, defineToolbarComponent,
  defineTooltipComponent, defineUserProfileComponent,
]) define();

IconRegistry.define([
  tylIconAdd, tylIconAdminPanelSettings, tylIconAutorenew, tylIconBadge, tylIconBarChart, tylIconCheckCircle,
  tylIconClose, tylIconCode, tylIconContentCopy, tylIconDeleteOutline, tylIconError, tylIconHistory, tylIconHome,
  tylIconInfo, tylIconMenuBook, tylIconOpenInNew, tylIconPeople, tylIconReceiptLong, tylIconRefresh,
  tylIconSchedule, tylIconSearch, tylIconSettings, tylIconTag, tylIconVpnKey, tylIconWarning,
  tylIconAutoAwesome, tylIconKeyboardArrowDown, tylIconKeyboardArrowUp, tylIconLightbulb, tylIconPiggyBank,
  tylIconShowChart, tylIconTableChart, tylIconArrowDownward, tylIconArrowUpward, tylIconUnfoldMore,
  tylIconAltRoute, tylIconMemory, tylIconPsychology,
]);

/**
 * forge-dark.css targets :root unconditionally, while the profile menu's theme toggle only
 * sets data-forge-theme on <html>. Bridge the two by switching the stylesheet's media query.
 */
export function installThemeBridge() {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = darkThemeUrl;
  document.head.append(link);
  const apply = () => {
    const theme = document.documentElement.getAttribute("data-forge-theme");
    link.media = theme === "dark" ? "all" : theme === "light" ? "not all" : "(prefers-color-scheme: dark)";
  };
  apply();
  new MutationObserver(apply).observe(document.documentElement, { attributes: true, attributeFilter: ["data-forge-theme"] });
}
